import React, { useEffect, useState, useMemo } from "react";
import { getEmployees, saveEmployee, getEmployeesWithDetails, searchEmployees } from "../../components/Api/GmsEmployee";
import Swal from "sweetalert2";
import API_URL from '../../config';
import { getGenders } from "../../components/Api/GmsGender";
import { getCountries } from "../../components/Api/GmsCountry";
import { getBusinesses } from "../../components/Api/GmsBusiness";
import { getDepartments } from "../../components/Api/GmsDepartment";
import { getDesignations } from "../../components/Api/GmsDesignation";
import { getBranches } from "../../components/Api/GmsBranch";
import {
  hasPagePermissionWithAdmin,
  hasViewOnlyPermission,
  hasEditOrHigherPermission,
  hasDeletePermissionWithAdmin,
  isUserAdmin
} from "../../components/Permission/PermissionService";
import { Card, CardBody, CardTitle, Col, Container, Row, Button, Table, Modal, ModalHeader, ModalBody, FormGroup, Input, Label } from "reactstrap";
import Select from "react-select";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import EmployeeForm from "../../components/EmployeeForm";
import { Users, Filter, Plus, Search, Briefcase, MapPin, Building2, User } from "lucide-react";
import { validateFile, resizeImage } from "../../utils/fileUploadHelper";

// Get user session
const getUserSession = () => {
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const normalizeId = (value) => {
    if (value === null || value === undefined || value === '' || value === 'null' || value === 'undefined') {
      return null;
    }
    const numValue = typeof value === 'string' ? parseInt(value, 10) : value;
    return isNaN(numValue) || numValue <= 0 ? null : numValue;
  };

  let businessId, branchId;

  if (authUser && Object.keys(authUser).length > 0) {
    businessId = normalizeId(authUser.companyId);
    branchId = normalizeId(authUser.branchId);
  } else {
    businessId = normalizeId(user.user_Company_Id || localStorage.getItem("userCompanyId"));
    branchId = normalizeId(user.user_Branch_Id || localStorage.getItem("userBranchId"));
  }

  return {
    userId: authUser.userId || 1,
    userName: authUser.userName || "System",
    businessId: businessId,
    branchId: branchId,
    companyId: businessId,
  };
};

const defaultForm = {
  employee_Id: null,
  employee_Code: "",
  employee_NameEn: "",
  employee_NameAr: "",
  employee_Business_Id: null,
  employee_Department_ID: null,
  employee_Designation_ID: null,
  employee_Branch_Id: null,
  employee_Gender_Id: null,
  employee_Country_Id: null,
  employee_Address1: "",
  employee_Address2: "",
  employee_BirthDate: "",
  employee_JoinDate: "",
  employee_NatID: "",
  employee_NatID_Date: "",
  employee_NatID_ExpDate: "",
  employee_PassportNumber: "",
  employee_Passport_Date: "",
  employee_Passport_ExpDate: "",
  employee_VisaNumber: "",
  employee_Visa_Date: "",
  employee_Visa_ExpDate: "",
  employee_ServiceEndDate: "",
  employee_BS: 0,
  employee_HRA: 0,
  employee_TA: 0,
  employee_OA: 0,
  employee_GS: 0,
  employee_IsOnProbation: true,
  employee_CreatedDate: new Date(),
  employee_CreatedBy: Number(localStorage.getItem("userId")) || 1,
  employee_ModifiedDate: new Date(),
  employee_ModifiedBy: Number(localStorage.getItem("userId")) || 1,
  employee_ImagePath: null,
  employee_Email: "",
  employee_LabourCardNumber: "",
  employee_LabourCardExpiry: "",
  employee_EmploymentType: "Permanent",
  employee_FoodAllowance: 0,
  employee_CommunicationAllowance: 0,
  employee_UtilityAllowance: 0,
  employee_HousingProvided: false,
  employee_TelephoneProvided: false,
  employee_FoodProvided: false,
  employee_OtherBenefits: false,
  employee_HousingAmount: 0,
  employee_TelephoneAmount: 0,
  employee_FoodAmount: 0,
  employee_OtherBenefitsAmount: 0,
  employee_ContactNumber1: "",
  employee_ContactNumber2: "",
  // New fields
  onWork: true,
  emp_No: "",
  wpsSalary: 0,
};

const emptyFilter = {
  employee_Id: null,
  employee_Code: "",
  employee_NameEn: "",
  employee_NameAr: "",
  employee_CreatedDate: null,
  employee_CreatedBy: null,
  employee_ModifiedDate: null,
  employee_ModifiedBy: null,
  employee_Business_Id: null,
  employee_Gender_Id: null,
  employee_BirthDate: null,
  employee_JoinDate: null,
  employee_Department_ID: null,
  employee_Designation_ID: null,
  employee_Branch_Id: null,
  employee_Country_Id: null,
  Branch: "",
  Gender: "",
  employee_Passport_Date: null,
  employee_Passport_ExpDate: null,
  employee_NatID: "",
  employee_NatID_Date: null,
  employee_NatID_ExpDate: null,
  employee_PassportNumber: "",
  employee_VisaNumber: "",
  employee_Visa_Date: null,
  employee_Visa_ExpDate: null,
  employee_Address1: "",
  employee_Address2: "",
  employee_ServiceEndDate: null,
  Country: "",
  Department: "",
  Designation: "",
  business_Name: "",
  employee_Email: "",
  employee_EmploymentType: null,
  employee_LabourCardNumber: "",
  employee_LabourCardExpiry: "",
  employee_FoodAllowance: null,
  employee_CommunicationAllowance: null,
  employee_UtilityAllowance: null,
  employee_HousingProvided: null,
  employee_TelephoneProvided: null,
  employee_FoodProvided: null,
  employee_OtherBenefits: null,
  employee_HousingAmount: null,
  employee_TelephoneAmount: null,
  employee_FoodAmount: null,
  employee_OtherBenefitsAmount: null,
  employee_ContactNumber1: "",
  employee_ContactNumber2: "",
  // New fields
  onWork: null,
  emp_No: "",
  wpsSalary: null,
};

const FormSelect = ({ label, id, name, options, value, onChange, error, required = true, isDisabled = false, icon: Icon }) => (
  <div className="form-group mb-2">
    <Label className="col-form-label pb-0" htmlFor={id} style={{ fontSize: '12px', fontWeight: '600', color: '#495057', marginBottom: '2px' }}>
      {label} {required && <span style={{ color: '#dc3545' }}>*</span>}
    </Label>
    <div style={{ position: 'relative' }}>
      {Icon && (
        <div style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', zIndex: 2, color: '#6c757d', pointerEvents: 'none' }}>
          <Icon size={16} />
        </div>
      )}
      <Select
        id={id}
        name={name}
        options={options}
        value={value}
        onChange={onChange}
        isClearable={!isDisabled}
        isSearchable
        isDisabled={isDisabled}
        placeholder={`Select ${label}`}
        classNamePrefix="select2-selection"
        className={error ? 'is-invalid' : ''}
        styles={{
          control: (provided, state) => ({
            ...provided,
            backgroundColor: isDisabled ? '#f8f9fa' : '#fff',
            borderColor: error ? '#dc3545' : (state.isFocused ? '#556ee6' : '#ced4da'),
            boxShadow: state.isFocused && !error ? '0 0 0 0.2rem rgba(85, 110, 230, 0.25)' : 'none',
            minHeight: '35px',
            borderRadius: '5px',
            fontSize: '13px',
            paddingLeft: Icon ? '35px' : '0px',
            '&:hover': { borderColor: error ? '#dc3545' : '#556ee6' }
          }),
          menu: (provided) => ({ ...provided, borderRadius: '6px', zIndex: 9999 }),
          menuPortal: (base) => ({ ...base, zIndex: 99999 }),
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#556ee6' : state.isFocused ? '#f8f9fa' : 'white',
            color: state.isSelected ? 'white' : '#495057',
            fontSize: '13px',
            padding: '8px 12px'
          }),
          placeholder: (providedX) => ({ ...providedX, fontSize: '13px' }),
          singleValue: (providedY) => ({ ...providedY, fontSize: '13px' })
        }}
        menuPortalTarget={document.body}
      />
    </div>
    {error && <div className="invalid-feedback d-block" style={{ fontSize: '12px' }}>{error}</div>}
  </div>
);

const FormInput = ({ label, id, name, type = "text", value, onChange, error, required = true, placeholder, disabled = false, readOnly = false, className = "", icon: Icon }) => (
  <div className="form-group mb-2">
    <Label className="col-form-label pb-0" htmlFor={id} style={{ fontSize: '12px', fontWeight: '600', color: '#495057', marginBottom: '2px' }}>
      {label} {required && <span style={{ color: '#dc3545' }}>*</span>}
    </Label>
    <div style={{ position: 'relative' }}>
      {Icon && (
        <div style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', zIndex: 1, color: '#6c757d', display: 'flex', alignItems: 'center' }}>
          <Icon size={16} />
        </div>
      )}
      <Input
        type={type}
        className={`form-control ${error ? 'is-invalid' : ''} ${className}`}
        id={id}
        name={name}
        value={value || ''}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        style={{
          paddingLeft: Icon ? '35px' : '12px',
          borderRadius: '5px',
          fontSize: '13px',
          height: '35px',
          borderColor: error ? '#dc3545' : '#ced4da'
        }}
      />
    </div>
    {error && <div className="invalid-feedback d-block" style={{ fontSize: '12px' }}>{error}</div>}
  </div>
);

const FormCheckbox = ({ label, id, name, checked, onChange, disabled = false }) => (
  <div className="form-group mb-2">
    <div className="form-check form-switch p-0" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <input
        type="checkbox"
        className="form-check-input ms-0"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        style={{ cursor: 'pointer', float: 'none' }}
      />
      <label className="form-check-label" htmlFor={id} style={{ fontSize: '13px', fontWeight: '500', cursor: 'pointer', margin: 0 }}>
        {label === "Active" ? (checked ? "Active" : "Inactive") : label}
      </label>
    </div>
  </div>
);

const FormBenefitCheckbox = ({ label, checkboxName, amountName, checkboxChecked, amountValue, onCheckboxChange, onAmountChange }) => (
  <div className="benefit-item">
    <div className="form-check">
      <Input
        type="checkbox"
        className="form-check-input"
        id={checkboxName}
        name={checkboxName}
        checked={checkboxChecked}
        onChange={onCheckboxChange}
      />
      <Label className="form-check-label" htmlFor={checkboxName}>
        {label}
      </Label>
    </div>
    {checkboxChecked && (
      <div className="mt-2">
        <Input
          type="number"
          name={amountName}
          value={amountValue || 0}
          onChange={onAmountChange}
          placeholder="Enter amount"
          min="0"
          step="any"
          className="form-control-sm"
        />
      </div>
    )}
  </div>
);

// Add this component for image preview
const ImagePreview = ({ file, existingImage }) => {
  if (!file && !existingImage) return null;

  let imageUrl;
  if (file) {
    imageUrl = URL.createObjectURL(file);
  } else if (existingImage) {
    // Prepend API_URL if existingImage is a relative path
    imageUrl = existingImage.startsWith('http') ? existingImage : `${API_URL}${existingImage}`;
  }

  return (
    <div className="mt-2">
      <img
        src={imageUrl}
        alt="Employee"
        style={{
          maxWidth: '200px',
          maxHeight: '200px',
          objectFit: 'cover',
          borderRadius: '8px'
        }}
      />
    </div>
  );
};

export default function EmployeePage() {
  const [employees, setEmployees] = useState([]);
  const [allFilteredEmployees, setAllFilteredEmployees] = useState([]); // Store all filtered employees for pagination
  const [employeeDropdownEmployees, setEmployeeDropdownEmployees] = useState([]); // Dedicated source for employee filter dropdowns
  const [employeeDropdownLoading, setEmployeeDropdownLoading] = useState(false);
  const [employeeNameSearchOptions, setEmployeeNameSearchOptions] = useState([]);
  const [employeeNameSearchLoading, setEmployeeNameSearchLoading] = useState(false);
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [genders, setGenders] = useState([]);
  const [countries, setCountries] = useState([]);
  const [errors, setErrors] = useState({});

  // Check permissions
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
  const hasPermission = hasPagePermissionWithAdmin(permissions, '/GmsEmployee');
  const isViewOnly = hasViewOnlyPermission(permissions, '/GmsEmployee');
  const hasEditOrHigher = hasEditOrHigherPermission(permissions, '/GmsEmployee');
  const hasDeletePermission = hasDeletePermissionWithAdmin(permissions, '/GmsEmployee');
  const isAdmin = isUserAdmin();

  // No tab logic needed anymore

  // Function to copy Address1 to Address2
  const copyAddress1ToAddress2 = () => {
    setForm(prevForm => ({
      ...prevForm,
      employee_Address2: prevForm.employee_Address1
    }));
  };
  const [businesses, setBusinesses] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [branches, setBranches] = useState([]);
  const [form, setForm] = useState(defaultForm);
  const [filter, setFilter] = useState(emptyFilter);
  const [showFilters, setShowFilters] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);
  const [viewModal, setViewModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const session = useMemo(() => getUserSession(), []);

  useEffect(() => {
    if (hasPermission) {
      const fetchData = async () => {
        try {
          const [
            gendersData,
            countriesData,
            businessesData,
            departmentsData,
            designationsData,
            branchesData
          ] = await Promise.all([
            getGenders(),
            getCountries(),
            getBusinesses({ business_Active: true }),
            getDepartments({}),
            getDesignations({}),
            getBranches({ branch_Active: true })
          ]);

          setGenders(gendersData || []);
          setCountries(countriesData || []);
          setBusinesses(businessesData || []);
          setDepartments(departmentsData || []);
          setDesignations(designationsData || []);
          setBranches(branchesData || []);
        } catch (error) {
          console.error("Error fetching data:", error);
          // Set empty arrays if API calls fail
          setGenders([]);
          setCountries([]);
          setBusinesses([]);
          setDepartments([]);
          setDesignations([]);
          setBranches([]);
        }
      };
      fetchData();
    } else {
      window.location.href = '/Dashboard';
    }
  }, [hasPermission]);

  // Auto-populate company in form if user has companyId
  useEffect(() => {
    if (session.businessId && businesses.length > 0 && !form.employee_Business_Id && !isEditing) {
      const business = businesses.find(b => b.business_Id === session.businessId);
      if (business) {
        setForm(prev => ({
          ...prev,
          employee_Business_Id: session.businessId
        }));
      }
    }
  }, [businesses, session.businessId, isEditing]);

  // Auto-populate branch in form if user has branchId
  useEffect(() => {
    if (session.branchId && branches.length > 0 && form.employee_Business_Id && !form.employee_Branch_Id && !isEditing) {
      const branch = branches.find(b => b.branch_Id === session.branchId);
      if (branch) {
        setForm(prev => ({
          ...prev,
          employee_Branch_Id: session.branchId
        }));
      }
    }
  }, [branches, session.branchId, form.employee_Business_Id, isEditing]);

  // Auto-populate filter and auto-load employees based on session data (companyId/branchId from login)
  const [hasLoadedInitialData, setHasLoadedInitialData] = useState(false);

  useEffect(() => {
    // Only run once on initial mount, after businesses and branches are loaded
    if (!hasPermission || hasLoadedInitialData) return;
    if (businesses.length === 0 || branches.length === 0) return; // Wait for data to load

    console.log("[GmsEmployee] Auto-load check", {
      sessionBusinessId: session.businessId,
      sessionBranchId: session.branchId,
      businessesLoaded: businesses.length,
      branchesLoaded: branches.length,
    });

    // Build filter based on session data
    const autoFilter = { ...emptyFilter };
    let shouldAutoLoad = false;

    if (session.businessId) {
      const business = businesses.find(b => b.business_Id === session.businessId);
      if (business) {
        autoFilter.employee_Business_Id = session.businessId;
        shouldAutoLoad = true;
        console.log("[GmsEmployee] Auto-populating filter with companyId:", session.businessId);
      }
    }

    if (session.branchId && autoFilter.employee_Business_Id) {
      const branch = branches.find(b => b.branch_Id === session.branchId);
      if (branch) {
        autoFilter.employee_Branch_Id = session.branchId;
        console.log("[GmsEmployee] Auto-populating filter with branchId:", session.branchId);
      }
    }

    // Set the filter state
    setFilter(autoFilter);

    // Auto-load employees immediately with the populated filter
    if (shouldAutoLoad) {
      console.log("[GmsEmployee] Auto-loading employees with filter:", autoFilter);
      loadEmployees(autoFilter, true);
      setHasLoadedInitialData(true);
    } else if (!session.businessId) {
      // If no session business, load all employees
      console.log("[GmsEmployee] No session companyId, loading all employees");
      loadEmployees(emptyFilter, true);
      setHasLoadedInitialData(true);
    } else {
      // If businessId exists but business not found, still mark as loaded to prevent infinite loop
      console.log("[GmsEmployee] Session businessId not found in businesses list, marking as loaded");
      setHasLoadedInitialData(true);
    }
  }, [hasPermission, businesses.length, branches.length, session.businessId, session.branchId]);

  /**
   * Keep Employee Code / Name dropdown options in sync with selected Company/Branch,
   * independent of the table pagination & "Apply Filter" button.
   *
   * This addresses the issue where dropdowns only show employees from the currently loaded page.
   */
  useEffect(() => {
    if (!hasPermission) return;

    const businessId = filter.employee_Business_Id ?? null;
    const branchId = filter.employee_Branch_Id ?? null;

    const timer = setTimeout(async () => {
      console.log("[GmsEmployee] Employee dropdown fetch start", {
        businessId,
        branchId,
      });

      // Build a minimal filter for dropdown scope (Company/Branch only)
      const cleanedFilter = {};
      if (businessId !== null && businessId !== undefined) cleanedFilter.Employee_Business_Id = businessId;
      if (branchId !== null && branchId !== undefined) cleanedFilter.Employee_Branch_Id = branchId;

      setEmployeeDropdownLoading(true);
      try {
        const data = await getEmployeesWithDetails(cleanedFilter);
        console.log("[GmsEmployee] Employee dropdown fetch success", {
          requestedFilter: cleanedFilter,
          returnedCount: Array.isArray(data) ? data.length : 0,
          sample: Array.isArray(data)
            ? data.slice(0, 5).map(e => ({ id: e.employee_Id, nameEn: e.employee_NameEn, branch: e.employee_Branch_Id, business: e.employee_Business_Id }))
            : [],
        });
        setEmployeeDropdownEmployees(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("[GmsEmployee] Employee dropdown fetch error", error);
        // Do NOT clear existing dropdown options on transient failures,
        // otherwise the UI falls back to paginated table data and looks like "only current page".
      } finally {
        setEmployeeDropdownLoading(false);
      }
    }, 250); // small debounce to avoid rapid calls while user changes selections

    return () => clearTimeout(timer);
  }, [hasPermission, filter.employee_Business_Id, filter.employee_Branch_Id]);

  // Bootstrap dropdown options from the table's full filtered list if needed
  useEffect(() => {
    if (employeeDropdownEmployees.length === 0 && allFilteredEmployees.length > 0) {
      console.log("[GmsEmployee] Bootstrap dropdown employees from table filtered dataset", {
        allFilteredEmployeesCount: allFilteredEmployees.length,
      });
      setEmployeeDropdownEmployees(allFilteredEmployees);
    }
  }, [allFilteredEmployees, employeeDropdownEmployees.length]);

  const loadEmployees = async (filterData = emptyFilter, resetPage = true) => {
    setLoading(true);
    try {
      // Clean up the filter: remove empty strings and convert them to null, remove null values for optional fields
      // Use PascalCase property names to match C# model (EmployeeFilter)
      const cleanedFilter = {};

      // Only include fields that have actual values (not empty strings, not null for optional fields)
      if (filterData.employee_Id) cleanedFilter.Employee_Id = filterData.employee_Id;
      if (filterData.employee_Code && filterData.employee_Code.trim() !== '') cleanedFilter.Employee_Code = filterData.employee_Code;
      if (filterData.employee_NameEn && filterData.employee_NameEn.trim() !== '') cleanedFilter.Employee_NameEn = filterData.employee_NameEn;
      if (filterData.employee_NameAr && filterData.employee_NameAr.trim() !== '') cleanedFilter.Employee_NameAr = filterData.employee_NameAr;
      if (filterData.employee_Business_Id !== null && filterData.employee_Business_Id !== undefined) {
        cleanedFilter.Employee_Business_Id = filterData.employee_Business_Id;
      }
      if (filterData.employee_Department_ID) cleanedFilter.Employee_Department_ID = filterData.employee_Department_ID;
      if (filterData.employee_Designation_ID) cleanedFilter.Employee_Designation_ID = filterData.employee_Designation_ID;
      if (filterData.employee_Branch_Id !== null && filterData.employee_Branch_Id !== undefined) {
        cleanedFilter.Employee_Branch_Id = filterData.employee_Branch_Id;
      }
      if (filterData.employee_Gender_Id) cleanedFilter.Employee_Gender_Id = filterData.employee_Gender_Id;
      if (filterData.employee_Country_Id) cleanedFilter.Employee_Country_Id = filterData.employee_Country_Id;
      if (filterData.employee_Email && filterData.employee_Email.trim() !== '') cleanedFilter.Employee_Email = filterData.employee_Email;
      if (filterData.employee_ContactNumber1 && filterData.employee_ContactNumber1.trim() !== '') cleanedFilter.Employee_ContactNumber1 = filterData.employee_ContactNumber1;
      if (filterData.employee_EmploymentType && filterData.employee_EmploymentType.trim() !== '') cleanedFilter.Employee_EmploymentType = filterData.employee_EmploymentType;
      if (filterData.OnWork !== null && filterData.OnWork !== undefined) cleanedFilter.OnWork = filterData.OnWork;
      if (filterData.Emp_No && filterData.Emp_No.trim() !== '') cleanedFilter.Emp_No = filterData.Emp_No;
      if (filterData.WpsSalary !== null && filterData.WpsSalary !== undefined) cleanedFilter.WpsSalary = filterData.WpsSalary;

      const data = await getEmployeesWithDetails(cleanedFilter);

      // Store all filtered employees for pagination
      setAllFilteredEmployees(data);
      setTotalCount(data.length);

      // Reset to page 1 if resetPage is true (when filter changes)
      if (resetPage) {
        setPage(1);
      }

      // Apply pagination to the filtered data
      const currentPage = resetPage ? 1 : page;
      const startIndex = (currentPage - 1) * pageSize;
      const endIndex = startIndex + pageSize;
      const paginatedData = data.slice(startIndex, endIndex);
      setEmployees(paginatedData);
    } catch (error) {
      alert("Error loading employees: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    let processedValue = type === "checkbox" ? checked : value;

    // Handle numeric fields
    if (['employee_BS', 'employee_HRA', 'employee_TA', 'employee_OA', 'wpsSalary',
      'employee_FoodAllowance', 'employee_CommunicationAllowance', 'employee_UtilityAllowance',
      'employee_HousingAmount', 'employee_TelephoneAmount', 'employee_FoodAmount', 'employee_OtherBenefitsAmount'].includes(name)) {
      // Prevent negative values
      if (value < 0) {
        setErrors(prev => ({
          ...prev,
          [name]: "Amount cannot be negative"
        }));
        return;
      }
      // Allow empty values to be converted to 0
      processedValue = value === '' ? 0 : parseFloat(value) || 0;

      // Special validation for WPS salary
      if (name === 'wpsSalary') {
        const currentGrossSalary =
          Number(form.employee_BS || 0) +
          Number(form.employee_HRA || 0) +
          Number(form.employee_TA || 0) +
          Number(form.employee_OA || 0) +
          Number(form.employee_FoodAllowance || 0) +
          Number(form.employee_CommunicationAllowance || 0) +
          Number(form.employee_UtilityAllowance || 0);

        if (processedValue > currentGrossSalary) {
          setErrors(prev => ({
            ...prev,
            [name]: "WPS Salary cannot exceed Gross Salary"
          }));
          return;
        }
      }
    }

    const updatedForm = { ...form, [name]: processedValue };

    // Clear error if value is valid
    if (errors[name]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }

    // Calculate gross salary only from regular salary components (excluding WpsSalary)
    if (['employee_BS', 'employee_HRA', 'employee_TA', 'employee_OA',
      'employee_FoodAllowance', 'employee_CommunicationAllowance', 'employee_UtilityAllowance'].includes(name)) {
      const grossSalary =
        Number(updatedForm.employee_BS || 0) +
        Number(updatedForm.employee_HRA || 0) +
        Number(updatedForm.employee_TA || 0) +
        Number(updatedForm.employee_OA || 0) +
        Number(updatedForm.employee_FoodAllowance || 0) +
        Number(updatedForm.employee_CommunicationAllowance || 0) +
        Number(updatedForm.employee_UtilityAllowance || 0);

      updatedForm.employee_GS = grossSalary;

      // Validate WPS salary against new gross salary
      if (Number(updatedForm.wpsSalary || 0) > grossSalary) {
        setErrors(prev => ({
          ...prev,
          wpsSalary: "WPS Salary cannot exceed Gross Salary"
        }));
        updatedForm.wpsSalary = grossSalary; // Automatically adjust WPS salary to match gross salary
      }
    }

    setForm(updatedForm);
  };

  const handleFilterChange = (e) => {
    setFilter({ ...filter, [e.target.name]: e.target.value || null });
  };

  const handleSelectFormChange = (selectedOption, field) => {
    setForm(prevForm => {
      const updatedForm = {
        ...prevForm,
        [field]: selectedOption ? selectedOption.value : null
      };

      // If business is changed, clear branch selection and reset branch options
      if (field === 'employee_Business_Id') {
        updatedForm.employee_Branch_Id = null;
      }

      return updatedForm;
    });
  };

  const handleImageChange = async (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      
      // Validate file (images only, max 5MB, no video)
      const validation = validateFile(file, { 
        maxSizeMB: 5, 
        allowedTypes: ['image/jpeg', 'image/png'] 
      });

      if (!validation.valid) {
        // Reset file input if validation fails
        e.target.value = "";
        return;
      }

      // Resize image to 512x512
      try {
        const resizedFile = await resizeImage(file, 512, 512);
        setSelectedImage(resizedFile);
        console.log('Processed image:', {
          name: resizedFile.name,
          type: resizedFile.type,
          size: resizedFile.size
        });
      } catch (error) {
        console.error("Error resizing image:", error);
        Swal.fire("Error", "Failed to process image.", "error");
      }
    }
  };

  const resetForm = () => {
    setForm({
      ...defaultForm,
      employee_CreatedDate: new Date(),
      employee_CreatedBy: Number(localStorage.getItem("userId")) || 1,
      employee_ModifiedDate: new Date(),
      employee_ModifiedBy: Number(localStorage.getItem("userId")) || 1
    });
    setSelectedImage(null);
    setIsEditing(false);
    setErrors({});

    // Reset file input by recreating it
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  // Validation function for mandatory fields
  const validateMandatoryFields = () => {
    const newErrors = {};

    // Mandatory fields according to requirements
    if (!form.employee_NameEn?.trim()) {
      newErrors.employee_NameEn = "Employee Name (English) is required";
    }
    if (!form.emp_No?.trim()) {
      newErrors.emp_No = "Employee Number is required";
    }
    // Employee Number character limit validation
    if (form.emp_No && form.emp_No.length > 10) {
      newErrors.emp_No = "Employee Number cannot exceed 10 characters";
    }
    if (!form.employee_Gender_Id) {
      newErrors.employee_Gender_Id = "Gender is required";
    }
    if (!form.employee_ContactNumber1?.trim()) {
      newErrors.employee_ContactNumber1 = "Primary Contact Number is required";
    }
    if (!form.employee_NatID?.trim()) {
      newErrors.employee_NatID = "National ID is required";
    }
    if (!form.employee_NatID_ExpDate) {
      newErrors.employee_NatID_ExpDate = "National ID Expiry Date is required";
    }
    if (!form.employee_PassportNumber?.trim()) {
      newErrors.employee_PassportNumber = "Passport Number is required";
    }
    if (!form.employee_Passport_ExpDate) {
      newErrors.employee_Passport_ExpDate = "Passport Expiry Date is required";
    }
    if (!form.employee_VisaNumber?.trim()) {
      newErrors.employee_VisaNumber = "Visa Number is required";
    }
    if (!form.employee_Visa_ExpDate) {
      newErrors.employee_Visa_ExpDate = "Visa Expiry Date is required";
    }
    if (!form.employee_LabourCardNumber?.trim()) {
      newErrors.employee_LabourCardNumber = "Labour Card Number is required";
    }
    if (!form.employee_LabourCardExpiry) {
      newErrors.employee_LabourCardExpiry = "Labour Card Expiry Date is required";
    }
    if (!form.employee_JoinDate) {
      newErrors.employee_JoinDate = "Joining Date is required";
    }
    if (!form.employee_BS || form.employee_BS <= 0) {
      newErrors.employee_BS = "Basic Salary is required and must be greater than 0";
    }
    if (!form.employee_HRA || form.employee_HRA < 0) {
      newErrors.employee_HRA = "HRA is required and cannot be negative";
    }
    if (!form.wpsSalary || form.wpsSalary <= 0) {
      newErrors.wpsSalary = "WPS Salary is required and must be greater than 0";
    }
    // Additional required fields as requested
    if (!form.employee_Address1?.trim()) {
      newErrors.employee_Address1 = "Address 1 is required";
    }
    if (!form.employee_Business_Id) {
      newErrors.employee_Business_Id = "Business is required";
    }
    if (!form.employee_Department_ID) {
      newErrors.employee_Department_ID = "Department is required";
    }
    if (!form.employee_Designation_ID) {
      newErrors.employee_Designation_ID = "Designation is required";
    }
    if (!form.employee_Branch_Id) {
      newErrors.employee_Branch_Id = "Branch is required";
    }
    if (!form.employee_BirthDate) {
      newErrors.employee_BirthDate = "Birth Date is required";
    }

    console.log('Validation errors:', newErrors);
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prevent multiple submissions
    if (loading) {
      return;
    }

    setLoading(true);

    console.log('Form data being submitted:', form);
    console.log('Mandatory fields check:');
    console.log('- Employee Name (English):', form.employee_NameEn);
    console.log('- Employee Number:', form.emp_No);
    console.log('- Gender:', form.employee_Gender_Id);
    console.log('- Primary Contact:', form.employee_ContactNumber1);
    console.log('- National ID:', form.employee_NatID);
    console.log('- National ID Expiry:', form.employee_NatID_ExpDate);
    console.log('- Passport Number:', form.employee_PassportNumber);
    console.log('- Passport Expiry:', form.employee_Passport_ExpDate);
    console.log('- Visa Number:', form.employee_VisaNumber);
    console.log('- Visa Expiry:', form.employee_Visa_ExpDate);
    console.log('- Labour Card Number:', form.employee_LabourCardNumber);
    console.log('- Labour Card Expiry:', form.employee_LabourCardExpiry);
    console.log('- Joining Date:', form.employee_JoinDate);
    console.log('- Basic Salary:', form.employee_BS);
    console.log('- HRA:', form.employee_HRA);
    console.log('- WPS Salary:', form.wpsSalary);

    // Validate mandatory fields
    const validationErrors = validateMandatoryFields();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      console.log('Form validation failed. Errors:', validationErrors);
      Swal.fire("Validation Error", "Please fill in all mandatory fields", "error");
      return;
    }

    try {
      const formData = new FormData();

      // Handle image file
      if (selectedImage) {
        // If a new image is selected, append it
        formData.append('imageFile', selectedImage);
        console.log('New image file being sent:', {
          name: selectedImage.name,
          type: selectedImage.type,
          size: selectedImage.size
        });
      } else if (isEditing && form.employee_ImagePath) {
        // If editing and there's an existing image path but no new image selected,
        // create a dummy file to satisfy the backend requirement
        const dummyFile = new File([''], 'dummy.txt', { type: 'text/plain' });
        formData.append('imageFile', dummyFile);
        formData.append('keepExistingImage', 'true'); // Flag to tell backend to keep existing image
      }

      // Add all form fields to FormData with proper handling and correct backend field names
      console.log('Adding form fields to FormData:');

      // Map frontend field names to backend model property names (match exact casing)
      const fieldMapping = {
        'employee_Id': 'Employee_Id',
        'employee_Code': 'Employee_Code',
        'employee_NameEn': 'Employee_NameEn',
        'employee_NameAr': 'Employee_NameAr',
        'employee_Gender_Id': 'Employee_Gender_Id',
        'employee_BirthDate': 'Employee_BirthDate',
        'employee_JoinDate': 'Employee_JoinDate',
        'employee_PassportNumber': 'Employee_PassportNumber',
        'employee_NatID': 'Employee_NatID',
        'employee_VisaNumber': 'Employee_VisaNumber',
        'employee_Passport_Date': 'Employee_Passport_Date',
        'employee_Passport_ExpDate': 'Employee_Passport_ExpDate',
        'employee_NatID_Date': 'Employee_NatID_Date',
        'employee_NatID_ExpDate': 'Employee_NatID_ExpDate',
        'employee_Visa_Date': 'Employee_Visa_Date',
        'employee_Visa_ExpDate': 'Employee_Visa_ExpDate',
        'employee_Country_Id': 'Employee_Country_Id',
        'employee_Address1': 'Employee_Address1',
        'employee_Address2': 'Employee_Address2',
        'employee_Department_ID': 'Employee_Department_ID',
        'employee_Designation_ID': 'Employee_Designation_ID',
        'employee_ServiceEndDate': 'Employee_ServiceEndDate',
        'employee_CreatedDate': 'Employee_CreatedDate',
        'employee_CreatedBy': 'Employee_CreatedBy',
        'employee_ModifiedDate': 'Employee_ModifiedDate',
        'employee_ModifiedBy': 'Employee_ModifiedBy',
        'employee_Business_Id': 'Employee_Business_Id',
        'employee_Branch_Id': 'Employee_Branch_Id',
        'employee_BS': 'Employee_BS',
        'employee_HRA': 'Employee_HRA',
        'employee_TA': 'Employee_TA',
        'employee_OA': 'Employee_OA',
        'employee_GS': 'Employee_GS',
        'employee_IsOnProbation': 'Employee_IsOnProbation',
        'employee_ImagePath': 'Employee_ImagePath',
        'employee_ContactNumber1': 'Employee_ContactNumber1',
        'employee_ContactNumber2': 'Employee_ContactNumber2',
        'employee_Email': 'Employee_Email',
        'employee_LabourCardNumber': 'Employee_LabourCardNumber',
        'employee_LabourCardExpiry': 'Employee_LabourCardExpiry',
        'employee_EmploymentType': 'Employee_EmploymentType',
        'employee_FoodAllowance': 'Employee_FoodAllowance',
        'employee_CommunicationAllowance': 'Employee_CommunicationAllowance',
        'employee_UtilityAllowance': 'Employee_UtilityAllowance',
        'employee_HousingProvided': 'Employee_HousingProvided',
        'employee_HousingAmount': 'Employee_HousingAmount',
        'employee_TelephoneProvided': 'Employee_TelephoneProvided',
        'employee_TelephoneAmount': 'Employee_TelephoneAmount',
        'employee_FoodProvided': 'Employee_FoodProvided',
        'employee_FoodAmount': 'Employee_FoodAmount',
        'employee_OtherBenefits': 'Employee_OtherBenefits',
        'employee_OtherBenefitsAmount': 'Employee_OtherBenefitsAmount',
        'onWork': 'OnWork',
        'emp_No': 'Emp_No',
        'wpsSalary': 'WpsSalary'
      };

      Object.keys(form).forEach(key => {
        const backendFieldName = fieldMapping[key] || key;

        if (key.includes('Date')) {
          // Format dates properly for backend
          if (form[key]) {
            const dateValue = new Date(form[key]).toISOString();
            formData.append(backendFieldName, dateValue);
            console.log(`Date field ${backendFieldName}:`, dateValue);
          } else {
            // Send null dates as empty string or current date for required fields
            if (['employee_CreatedDate', 'employee_ModifiedDate'].includes(key)) {
              const currentDate = new Date().toISOString();
              formData.append(backendFieldName, currentDate);
              console.log(`Required date field ${backendFieldName} (auto-set):`, currentDate);
            } else {
              formData.append(backendFieldName, '');
              console.log(`Optional date field ${backendFieldName}:`, 'empty');
            }
          }
        } else {
          // Handle non-date fields
          let value = form[key];

          // Ensure numeric fields are properly formatted
          if (['employee_Business_Id', 'employee_Department_ID', 'employee_Designation_ID',
            'employee_Branch_Id', 'employee_Gender_Id', 'employee_Country_Id',
            'employee_CreatedBy', 'employee_ModifiedBy'].includes(key)) {
            value = value || 0;
          }

          // Ensure boolean fields are properly formatted
          if (['employee_IsOnProbation', 'onWork', 'employee_HousingProvided',
            'employee_TelephoneProvided', 'employee_FoodProvided', 'employee_OtherBenefits'].includes(key)) {
            value = value === true || value === 'true' ? true : false;
          }

          // Ensure decimal fields are properly formatted
          if (['employee_BS', 'employee_HRA', 'employee_TA', 'employee_OA', 'employee_GS',
            'wpsSalary', 'employee_FoodAllowance', 'employee_CommunicationAllowance',
            'employee_UtilityAllowance', 'employee_HousingAmount', 'employee_TelephoneAmount',
            'employee_FoodAmount', 'employee_OtherBenefitsAmount'].includes(key)) {
            value = value || 0;
          }

          formData.append(backendFieldName, value !== null && value !== undefined ? value : '');
          console.log(`Field ${backendFieldName}:`, value);
        }
      });

      console.log('FormData entries:');
      for (let [key, value] of formData.entries()) {
        if (key === 'imageFile') {
          console.log('imageFile:', value.name);
        } else {
          console.log(key + ':', value);
        }
      }

      const response = await fetch(`${API_URL}/api/Employee/save`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: formData
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Import and use the session timeout handler
          const { handleSessionTimeout } = await import('../../components/Api/SessionTimeoutHandler');
          handleSessionTimeout();
          throw new Error('Session timed out. Please login again.');
        }

        // Try to get error details from response
        let errorMessage = 'Failed to save employee';
        try {
          const errorResponse = await response.json();
          console.error('Backend error response:', errorResponse);
          errorMessage = errorResponse.msg || errorResponse.message || errorMessage;
        } catch (e) {
          console.error('Could not parse error response:', e);
        }

        throw new Error(errorMessage);
      }

      const result = await response.json();
      console.log('Save employee response:', result);

      if (result.id) {  // Check for id in the response to determine success
        Swal.fire("Success", result.msg || "Employee saved successfully", "success");
        resetForm(); // Use the new reset function
        loadEmployees(filter, false); // Reload the employee list with current filter, don't reset page
        setIsEditing(false); // Exit edit mode
      } else {
        Swal.fire("Error", result.msg || "Failed to save employee", "error");
      }
    } catch (error) {
      console.error('Error saving employee:', error);
      Swal.fire("Error", `Failed to save employee: ${error.message}`, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (employee) => {
    console.log("Edit employee:", employee);
    const formatDate = (dateString) => dateString ? new Date(dateString).toISOString().split('T')[0] : "";

    setForm({
      employee_Id: employee.employee_Id,
      employee_Code: employee.employee_Code || "",
      employee_NameEn: employee.employee_NameEn || "",
      employee_NameAr: employee.employee_NameAr || "",
      employee_Business_Id: employee.employee_Business_Id || null,
      employee_Department_ID: employee.employee_Department_ID || null,
      employee_Designation_ID: employee.employee_Designation_ID || null,
      employee_Branch_Id: employee.employee_Branch_Id || null,
      employee_Gender_Id: employee.employee_Gender_Id || null,
      employee_Country_Id: employee.employee_Country_Id || null,
      employee_Address1: employee.employee_Address1 || "",
      employee_Address2: employee.employee_Address2 || "",
      employee_BirthDate: formatDate(employee.employee_BirthDate),
      employee_JoinDate: formatDate(employee.employee_JoinDate),
      employee_NatID: employee.employee_NatID || "",
      employee_NatID_Date: formatDate(employee.employee_NatID_Date),
      employee_NatID_ExpDate: formatDate(employee.employee_NatID_ExpDate),
      employee_PassportNumber: employee.employee_PassportNumber || "",
      employee_Passport_Date: formatDate(employee.employee_Passport_Date),
      employee_Passport_ExpDate: formatDate(employee.employee_Passport_ExpDate),
      employee_VisaNumber: employee.employee_VisaNumber || "",
      employee_Visa_Date: formatDate(employee.employee_Visa_Date),
      employee_Visa_ExpDate: formatDate(employee.employee_Visa_ExpDate),
      employee_ServiceEndDate: formatDate(employee.employee_ServiceEndDate),
      employee_BS: employee.employee_BS || 0,
      employee_HRA: employee.employee_HRA || 0,
      employee_TA: employee.employee_TA || 0,
      employee_OA: employee.employee_OA || 0,
      employee_GS: employee.employee_GS || 0,
      employee_IsOnProbation: employee.employee_IsOnProbation || false,
      employee_CreatedDate: new Date(employee.employee_CreatedDate || new Date()),
      employee_CreatedBy: employee.employee_CreatedBy || Number(localStorage.getItem("userId")) || 1,
      employee_ModifiedDate: new Date(),
      employee_ModifiedBy: Number(localStorage.getItem("userId")) || 1,
      employee_ImagePath: employee.employee_ImagePath || null,
      employee_Email: employee.employee_Email || "",
      employee_LabourCardNumber: employee.employee_LabourCardNumber || "",
      employee_LabourCardExpiry: formatDate(employee.employee_LabourCardExpiry),
      employee_EmploymentType: employee.employee_EmploymentType || "Permanent",
      employee_FoodAllowance: employee.employee_FoodAllowance || 0,
      employee_CommunicationAllowance: employee.employee_CommunicationAllowance || 0,
      employee_UtilityAllowance: employee.employee_UtilityAllowance || 0,
      employee_HousingProvided: employee.employee_HousingProvided || false,
      employee_TelephoneProvided: employee.employee_TelephoneProvided || false,
      employee_FoodProvided: employee.employee_FoodProvided || false,
      employee_OtherBenefits: employee.employee_OtherBenefits || false,
      employee_HousingAmount: employee.employee_HousingAmount || 0,
      employee_TelephoneAmount: employee.employee_TelephoneAmount || 0,
      employee_FoodAmount: employee.employee_FoodAmount || 0,
      employee_OtherBenefitsAmount: employee.employee_OtherBenefitsAmount || 0,
      employee_ContactNumber1: employee.employee_ContactNumber1 || "",
      employee_ContactNumber2: employee.employee_ContactNumber2 || "",
      // New fields
      onWork: employee.onWork || false,
      emp_No: employee.emp_No || "",
      wpsSalary: employee.wpsSalary || 0,
    });

    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    resetForm(); // Use the same reset function for consistency
    setIsEditing(false);
  };

  const handleFormSuccess = () => {
    resetForm();
    loadEmployees(filter, false); // Reload with current filter, don't reset page
    setIsEditing(false);
  };

  const handleApplyFilter = () => {
    setHasLoadedInitialData(false); // Reset flag so we can reload
    loadEmployees(filter, true); // Reset to page 1 when filter is applied
  };

  const handleClearFilter = () => {
    setFilter(emptyFilter);
    setEmployeeNameSearchOptions([]);
    setHasLoadedInitialData(false); // Reset flag so we can reload
    loadEmployees(emptyFilter, true); // Reset to page 1 when filter is cleared
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Tab functionality removed

  // Generate options for searchable dropdowns
  // IMPORTANT:
  // - Prefer `employeeDropdownEmployees` (kept in sync with Company/Branch selection).
  // - Fallback to `allFilteredEmployees` (table's full filtered dataset).
  // - Finally fallback to `employees` (current page slice).
  const optionSourceEmployees =
    employeeDropdownEmployees.length > 0
      ? employeeDropdownEmployees
      : (allFilteredEmployees.length > 0 ? allFilteredEmployees : employees);

  console.log("[GmsEmployee] Dropdown option source", {
    optionSourceCount: optionSourceEmployees.length,
    employeeDropdownEmployeesCount: employeeDropdownEmployees.length,
    allFilteredEmployeesCount: allFilteredEmployees.length,
    currentPageEmployeesCount: employees.length,
  });

  const employeeCodeOptions = [...new Set(optionSourceEmployees.map(emp => emp.employee_Code).filter(Boolean))].map(code => ({
    value: code,
    label: code
  }));

  const employeeNameEnOptions = [...new Set(optionSourceEmployees.map(emp => emp.employee_NameEn).filter(Boolean))].map(name => ({
    value: name,
    label: name
  }));

  const employeeNameArOptions = [...new Set(optionSourceEmployees.map(emp => emp.employee_NameAr).filter(Boolean))].map(name => ({
    value: name,
    label: name
  }));

  const businessOptions = businesses.map(business => ({
    value: business.business_Id,
    label: `${business.business_NameEn} - ${business.business_NameAr}`
  }));

  // Transform gender and country data for Select component
  const genderOptions = genders.map(gender => ({
    value: gender.gender_Id,
    label: `${gender.gender_NameEn} - ${gender.gender_NameAr}`
  }));

  const countryOptions = countries.map(country => ({
    value: country.country_Id,
    label: `${country.country_NameEn} - ${country.country_NameAr}`
  }));

  const departmentOptions = departments.map(dept => ({
    value: dept.department_Id,
    label: `${dept.department_NameEn} - ${dept.department_NameAr}`
  }));

  const designationOptions = designations.map(desig => ({
    value: desig.designation_Id,
    label: `${desig.designation_NameEn} - ${desig.designation_NameAr}`
  }));

  // Filter branches based on selected business
  const filteredBranches = form.employee_Business_Id
    ? branches.filter(branch => branch.branch_Buisness_Id === form.employee_Business_Id)
    : branches;

  const branchOptions = filteredBranches.map(branch => ({
    value: branch.branch_Id,
    label: `${branch.branch_NameEn} - ${branch.branch_NameAr}`
  }));

  // Filter branches for filter section based on selected business in filter
  const filteredBranchesForFilter = filter.employee_Business_Id
    ? branches.filter(branch => branch.branch_Buisness_Id === filter.employee_Business_Id)
    : branches;

  const branchOptionsForFilter = filteredBranchesForFilter.map(branch => ({
    value: branch.branch_Id,
    label: `${branch.branch_NameEn} - ${branch.branch_NameAr}`
  }));

  const createdByOptions = [...new Set(optionSourceEmployees.map(emp => emp.employee_CreatedBy).filter(Boolean))].map(id => ({
    value: id,
    label: id.toString()
  }));

  const modifiedByOptions = [...new Set(optionSourceEmployees.map(emp => emp.employee_ModifiedBy).filter(Boolean))].map(id => ({
    value: id,
    label: id.toString()
  }));

  // Manual search function for employee name filter search
  const searchEmployeeNamesManually = async (inputValue) => {
    if (!inputValue || inputValue.length < 3) {
      setEmployeeNameSearchOptions([]);
      return;
    }

    try {
      setEmployeeNameSearchLoading(true);
      // Pass the selected company and branch from filter
      const businessId = filter.employee_Business_Id || null;
      const branchId = filter.employee_Branch_Id || null;
      const response = await searchEmployees(inputValue, 1, 20, businessId, branchId);

      const formattedOptions = response.items.map(employee => ({
        value: employee.employee_NameEn,
        label: `${employee.employee_NameEn || 'N/A'} — ${employee.emp_No || employee.Emp_No || 'N/A'}`,
        employee: employee
      }));

      setEmployeeNameSearchOptions(formattedOptions);
    } catch (error) {
      console.error('Error searching employees:', error);
      setEmployeeNameSearchOptions([]);
    } finally {
      setEmployeeNameSearchLoading(false);
    }
  };

  const handleSelectChange = (selectedOption, field) => {
    setFilter(prevFilter => {
      const updatedFilter = {
        ...prevFilter,
        [field]: selectedOption ? selectedOption.value : null
      };

      // If business is changed in filter, clear branch selection and employee name search
      if (field === 'employee_Business_Id') {
        updatedFilter.employee_Branch_Id = null;
        updatedFilter.employee_NameEn = null;
        setEmployeeNameSearchOptions([]);
      }

      // If branch is changed, clear employee name search
      if (field === 'employee_Branch_Id') {
        updatedFilter.employee_NameEn = null;
        setEmployeeNameSearchOptions([]);
      }

      return updatedFilter;
    });
  };

  const handlePageChange = (newPage) => {
    // Use the stored filtered employees for pagination instead of re-fetching
    if (allFilteredEmployees.length === 0) {
      // If no filtered data, reload with current filter
      loadEmployees(filter, false);
      return;
    }

    setPage(newPage);
    const startIndex = (newPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const paginatedData = allFilteredEmployees.slice(startIndex, endIndex);
    setEmployees(paginatedData);
  };

  // Add this new function to handle view button click
  const handleView = (employee) => {
    setSelectedEmployee(employee);
    setViewModal(true);
  };

  // Add the Employee Details Modal component
  const EmployeeDetailsModal = ({ isOpen, toggle, employee }) => {
    if (!employee) return null;

    const InfoSection = ({ title, children }) => (
      <div className="employee-info-section">
        <h5 className="text-primary border-bottom">{title}</h5>
        <div className="px-2">{children}</div>
      </div>
    );

    const InfoItem = ({ label, value }) => (
      <div className="info-item mb-3">
        <strong className="info-label">{label}:</strong>
        <span className="info-value">{value}</span>
      </div>
    );

    const DateRangeItem = ({ label, startDate, endDate }) => (
      <div className="info-item mb-3">
        <strong className="info-label">{label}:</strong>
        <div className="date-range">
          <div className="small text-muted">
            <i className="bx bx-calendar me-1"></i>Valid from {formatDate(startDate)} to {formatDate(endDate)}
          </div>
        </div>
      </div>
    );

    const MoneyItem = ({ label, value }) => (
      <div className="info-item mb-3">
        <strong className="info-label">{label}:</strong>
        <span className="salary-value">
          {value?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </span>
      </div>
    );

    const BenefitItem = ({ label, isProvided, amount }) => (
      <div className="info-item mb-3">
        <strong className="info-label">{label}:</strong>
        <div>
          <span className={`badge ${isProvided ? 'bg-success' : 'bg-secondary'} me-2`}>
            {isProvided ? 'Provided' : 'Not Provided'}
          </span>
          {isProvided && amount > 0 && (
            <span className="salary-value">
              Amount: {amount?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
          )}
        </div>
      </div>
    );

    return (
      <Modal isOpen={isOpen} toggle={toggle} size="lg" className="employee-details-modal">
        <ModalHeader toggle={toggle} className="border-bottom py-2">
          <i className="bx bx-user-circle me-2"></i>
          Employee Details
        </ModalHeader>
        <ModalBody className="p-3">
          <style>
            {`
              .employee-details-modal .modal-content {
                border-radius: 12px;
                box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
              }
              .employee-info-section {
                background-color: #fff;
                border-radius: 8px;
                padding: 15px;
                margin-bottom: 15px;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
              }
              .info-item {
                display: flex;
                align-items: baseline;
                margin-bottom: 8px;
                padding: 4px 15px;
              }
              .info-label {
                min-width: 120px;
                color: #495057;
                font-size: 0.9rem;
                flex: 0 0 120px;
              }
              .info-value {
                flex: 1;
                padding-left: 15px;
                color: #212529;
              }
              .date-range {
                flex: 1;
                padding-left: 15px;
              }
              .profile-image-container {
                padding: 15px;
                text-align: center;
                background: linear-gradient(to bottom, #f8f9fa, #fff);
                border-radius: 8px;
                margin-bottom: 15px;
              }
              .salary-value {
                font-family: monospace;
                background-color: #f8f9fa;
                padding: 2px 8px;
                border-radius: 4px;
                color: #28a745;
              }
              .document-section {
                background-color: #f8f9fa;
                border-radius: 8px;
                padding: 8px;
                margin-top: 8px;
              }
              .modal-body {
                padding: 15px !important;
              }
              .row {
                margin-left: -7.5px;
                margin-right: -7.5px;
              }
              .col-md-6 {
                padding-left: 7.5px;
                padding-right: 7.5px;
              }
              h5.text-primary {
                font-size: 1rem;
                margin-bottom: 10px;
                padding-bottom: 8px;
              }
              .employee-details-modal .modal-content {
                max-height: 85vh;
                overflow-y: auto;
              }
              .employee-details-modal .modal-body::-webkit-scrollbar {
                width: 8px;
              }
              .employee-details-modal .modal-body::-webkit-scrollbar-track {
                background: #f1f1f1;
              }
              .employee-details-modal .modal-body::-webkit-scrollbar-thumb {
                background: #888;
                border-radius: 4px;
              }
              .employee-details-modal .modal-body::-webkit-scrollbar-thumb:hover {
                background: #555;
              }
            `}
          </style>

          <div className="profile-image-container">
            {employee.employee_ImagePath ? (
              <img
                src={`${API_URL}${employee.employee_ImagePath}`}
                alt={employee.employee_NameEn}
                style={{
                  width: '200px',
                  height: '200px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                  border: '5px solid #fff',
                  boxShadow: '0 0 15px rgba(0,0,0,0.1)'
                }}
              />
            ) : (
              <div
                style={{
                  width: '200px',
                  height: '200px',
                  borderRadius: '50%',
                  backgroundColor: '#e9ecef',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto',
                  border: '5px solid #fff',
                  boxShadow: '0 0 15px rgba(0,0,0,0.1)'
                }}
              >
                <i className="bx bx-user" style={{ fontSize: '64px', color: '#adb5bd' }} />
              </div>
            )}
            <h4 className="mt-3 mb-0">{employee.employee_NameEn}</h4>
            <p className="text-muted mb-0">{employee.employee_NameAr}</p>
          </div>

          <Row>
            <Col md="6">
              <InfoSection title="Personal Information">
                <InfoItem label="Employee Code" value={employee.employee_Code} />
                <InfoItem label="Employee Number" value={employee.emp_No} />
                <InfoItem label="Gender" value={employee.gender_name} />
                <InfoItem label="Birth Date" value={formatDate(employee.employee_BirthDate)} />
                <InfoItem label="Country" value={employee.country_name} />
                <InfoItem label="Email" value={employee.employee_Email} />
                <InfoItem label="Primary Contact" value={employee.employee_ContactNumber1} />
                <InfoItem label="Secondary Contact" value={employee.employee_ContactNumber2} />
                <InfoItem
                  label="Work Status"
                  value={
                    <span className={`badge ${employee.onWork ? 'bg-success' : 'bg-secondary'}`}>
                      {employee.onWork ? 'On Work' : 'Not On Work'}
                    </span>
                  }
                />
              </InfoSection>

              <InfoSection title="Address Information">
                <InfoItem label="Address 1" value={employee.employee_Address1} />
                <InfoItem label="Address 2" value={employee.employee_Address2} />
              </InfoSection>

              <InfoSection title="Documents">
                <div className="document-section">
                  <InfoItem label="National ID" value={employee.employee_NatID} />
                  <DateRangeItem
                    label="Validity"
                    startDate={employee.employee_NatID_Date}
                    endDate={employee.employee_NatID_ExpDate}
                  />
                </div>

                <div className="document-section mt-3">
                  <InfoItem label="Passport" value={employee.employee_PassportNumber} />
                  <DateRangeItem
                    label="Validity"
                    startDate={employee.employee_Passport_Date}
                    endDate={employee.employee_Passport_ExpDate}
                  />
                </div>

                <div className="document-section mt-3">
                  <InfoItem label="Visa" value={employee.employee_VisaNumber} />
                  <DateRangeItem
                    label="Validity"
                    startDate={employee.employee_Visa_Date}
                    endDate={employee.employee_Visa_ExpDate}
                  />
                </div>
              </InfoSection>
            </Col>

            <Col md="6">
              <InfoSection title="Employment Information">
                <InfoItem label="Company" value={employee.business_name} />
                <InfoItem label="Department" value={employee.department_name} />
                <InfoItem label="Designation" value={employee.designation_name} />
                <InfoItem label="Branch" value={employee.branch_name} />
                <InfoItem label="Join Date" value={formatDate(employee.employee_JoinDate)} />
                <InfoItem label="Employment Type" value={employee.employee_EmploymentType} />
                <InfoItem label="Labour Card Number" value={employee.employee_LabourCardNumber} />
                <InfoItem label="Labour Card Expiry" value={formatDate(employee.employee_LabourCardExpiry)} />
                <InfoItem
                  label="Status"
                  value={
                    <span className={`badge ${employee.employee_IsOnProbation ? 'bg-warning' : 'bg-success'}`}>
                      {employee.employee_IsOnProbation ? 'On Probation' : 'Confirmed'}
                    </span>
                  }
                />
              </InfoSection>

              <InfoSection title="Salary Information">
                <MoneyItem label="Basic Salary" value={employee.employee_BS} />
                <MoneyItem label="HRA" value={employee.employee_HRA} />
                <MoneyItem label="Transport" value={employee.employee_TA} />
                <MoneyItem label="Other Allowance" value={employee.employee_OA} />
                <MoneyItem label="Food Allowance" value={employee.employee_FoodAllowance} />
                <MoneyItem label="Communication Allowance" value={employee.employee_CommunicationAllowance} />
                <MoneyItem label="Utility Allowance" value={employee.employee_UtilityAllowance} />
                <MoneyItem label="WPS Salary" value={employee.wpsSalary} />
                <div className="mt-3 pt-3 border-top">
                  <MoneyItem
                    label="Gross Salary"
                    value={employee.employee_GS}
                  />
                </div>
              </InfoSection>

              <InfoSection title="Group Benefits">
                <BenefitItem
                  label="Housing Benefit"
                  isProvided={employee.employee_HousingProvided}
                  amount={employee.employee_HousingAmount}
                />
                <BenefitItem
                  label="Telephone Benefit"
                  isProvided={employee.employee_TelephoneProvided}
                  amount={employee.employee_TelephoneAmount}
                />
                <BenefitItem
                  label="Food Benefit"
                  isProvided={employee.employee_FoodProvided}
                  amount={employee.employee_FoodAmount}
                />
                <BenefitItem
                  label="Other Benefits"
                  isProvided={employee.employee_OtherBenefits}
                  amount={employee.employee_OtherBenefitsAmount}
                />
              </InfoSection>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content space-optimized">
        <Container fluid={true}>
          <Breadcrumbs title="Employee" breadcrumbItem="Employee Management" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center mb-4 pb-2 border-bottom">
                    <div style={{ width: '32px', height: '32px', borderRadius: '8px', backgroundColor: 'rgba(85, 110, 230, 0.1)', color: '#556ee6', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '12px' }}>
                      <Users size={20} />
                    </div>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div>
                        <h5 className="mb-0" style={{ fontWeight: '700', fontSize: '18px', color: '#495057' }}>Employee Management</h5>
                        <p className="text-muted mb-0" style={{ fontSize: '13px' }}>View and manage organization staff directory</p>
                      </div>
                      <Link to="/GmsAddEmployee">
                        <Button color="primary" className="btn-rounded waves-effect waves-light" style={{ padding: '8px 20px', fontSize: '13px', fontWeight: '600' }}>
                          <Plus size={16} className="me-1" /> Add New Employee
                        </Button>
                      </Link>
                    </div>
                  </div>

                  {/* Edit Form - Only shown when editing */}
                  {isEditing && hasEditOrHigher && (
                    <Card className="mb-4" style={{ border: '2px solid #556ee6' }}>
                      <CardBody>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h5 className="mb-0 text-primary">Edit Employee</h5>
                          <Button color="secondary" size="sm" onClick={handleCancelEdit}>
                            Cancel Edit
                          </Button>
                        </div>
                        <EmployeeForm
                          form={form}
                          setForm={setForm}
                          errors={errors}
                          setErrors={setErrors}
                          loading={loading}
                          setLoading={setLoading}
                          isEditing={true}
                          onSuccess={handleFormSuccess}
                          onCancel={handleCancelEdit}
                          genders={genders}
                          countries={countries}
                          businesses={businesses}
                          departments={departments}
                          designations={designations}
                          branches={branches}
                          hasDeletePermission={hasDeletePermission}
                          isCompanyDisabled={!!session.businessId}
                          isBranchDisabled={!!session.branchId}
                        />
                      </CardBody>
                    </Card>
                  )}

                  {/* Employee List Section */}
                  <div>
                    {/* Filter Section */}
                    <div className="mb-4">
                      <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                        <div style={{ width: '28px', height: '28px', borderRadius: '5px', backgroundColor: 'rgba(23, 162, 184, 0.1)', color: '#17a2b8', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '10px' }}>
                          <Filter size={16} />
                        </div>
                        <h6 className="mb-0" style={{ fontWeight: 'bold', fontSize: '14px', color: '#17a2b8', fontFamily: "'Poppins', sans-serif" }}>Filters</h6>
                      </div>
                      <div className="d-flex align-items-center gap-2 mb-3">
                        <Button
                          color="primary"
                          size="sm"
                          onClick={() => setShowFilters(!showFilters)}
                        >
                          {showFilters ? "Hide Filters" : "Show Filters"}
                        </Button>
                      </div>

                      {showFilters && (
                        <Card>
                          <CardBody style={{ padding: '1rem' }}>
                            {/* Row 1: Company, Branch, Department, Designation, Employee Code */}
                            <Row className="mb-2" style={{ display: 'flex', flexWrap: 'wrap' }}>
                              <Col style={{ flex: '1', minWidth: '180px', maxWidth: '20%', paddingLeft: '8px', paddingRight: '8px' }}>
                                <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                  <Label htmlFor="filter_employee_Business_Id">Company</Label>
                                  <Select
                                    id="filter_employee_Business_Id"
                                    name="filter_employee_Business_Id"
                                    options={businessOptions}
                                    value={businessOptions.find(option => option.value === filter.employee_Business_Id)}
                                    placeholder="Select"
                                    classNamePrefix="select2-selection"
                                    isClearable={!session.businessId}
                                    isSearchable={true}
                                    isDisabled={!!session.businessId}
                                    onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_Business_Id')}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 99999 }) }}
                                  />
                                </div>
                              </Col>

                              <Col style={{ flex: '1', minWidth: '180px', maxWidth: '20%', paddingLeft: '8px', paddingRight: '8px' }}>
                                <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                  <Label htmlFor="filter_employee_Branch_Id">Branch</Label>
                                  <Select
                                    id="filter_employee_Branch_Id"
                                    name="filter_employee_Branch_Id"
                                    options={branchOptionsForFilter}
                                    value={branchOptionsForFilter.find(option => option.value === filter.employee_Branch_Id)}
                                    placeholder="Select"
                                    classNamePrefix="select2-selection"
                                    isClearable={!session.branchId}
                                    isSearchable={true}
                                    isDisabled={!!session.branchId || !filter.employee_Business_Id}
                                    onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_Branch_Id')}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 99999 }) }}
                                  />
                                </div>
                              </Col>

                              <Col style={{ flex: '1', minWidth: '180px', maxWidth: '20%', paddingLeft: '8px', paddingRight: '8px' }}>
                                <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                  <Label htmlFor="filter_employee_Department_ID">Department</Label>
                                  <Select
                                    id="filter_employee_Department_ID"
                                    name="filter_employee_Department_ID"
                                    options={departmentOptions}
                                    value={departmentOptions.find(option => option.value === filter.employee_Department_ID)}
                                    placeholder="Select"
                                    classNamePrefix="select2-selection"
                                    isClearable={true}
                                    isSearchable={true}
                                    onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_Department_ID')}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 99999 }) }}
                                  />
                                </div>
                              </Col>

                              <Col style={{ flex: '1', minWidth: '180px', maxWidth: '20%', paddingLeft: '8px', paddingRight: '8px' }}>
                                <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                  <Label htmlFor="filter_employee_Designation_ID">Designation</Label>
                                  <Select
                                    id="filter_employee_Designation_ID"
                                    name="filter_employee_Designation_ID"
                                    options={designationOptions}
                                    value={designationOptions.find(option => option.value === filter.employee_Designation_ID)}
                                    placeholder="Select"
                                    classNamePrefix="select2-selection"
                                    isClearable={true}
                                    isSearchable={true}
                                    onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_Designation_ID')}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 99999 }) }}
                                  />
                                </div>
                              </Col>

                              <Col style={{ flex: '1', minWidth: '180px', maxWidth: '20%', paddingLeft: '8px', paddingRight: '8px' }}>
                                <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                  <Label htmlFor="filter_employee_Code">Employee Code</Label>
                                  <Select
                                    options={employeeCodeOptions}
                                    value={employeeCodeOptions.find(option => option.value === filter.employee_Code)}
                                    placeholder="Select"
                                    classNamePrefix="select2-selection"
                                    isClearable={true}
                                    isSearchable={true}
                                    isLoading={employeeDropdownLoading}
                                    onChange={(selectedOption) => {
                                      const value = selectedOption ? selectedOption.value : '';
                                      setFilter(prev => ({ ...prev, employee_Code: value }));
                                    }}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 99999 }) }}
                                  />
                                </div>
                              </Col>
                            </Row>

                            {/* Row 2: Employee Name, Gender, Country, Join Date, Birth Date */}
                            <Row className="mb-2" style={{ display: 'flex', flexWrap: 'wrap' }}>
                              <Col style={{ flex: '1', minWidth: '180px', maxWidth: '20%', paddingLeft: '8px', paddingRight: '8px' }}>
                                <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                  <Label htmlFor="filter_employee_NameEn">Name (English)</Label>
                                  <Select
                                    options={employeeNameSearchOptions}
                                    value={employeeNameSearchOptions.find(option => option.value === filter.employee_NameEn)}
                                    placeholder="Type at least 3 characters to search..."
                                    classNamePrefix="select2-selection"
                                    isClearable={true}
                                    isSearchable={true}
                                    isLoading={employeeNameSearchLoading}
                                    filterOption={() => true}
                                    noOptionsMessage={({ inputValue }) => {
                                      if (employeeNameSearchLoading) return "Searching...";
                                      if (!inputValue || inputValue.length < 3) return "Type at least 3 characters to search";
                                      if (employeeNameSearchOptions.length === 0) return "No employees found";
                                      return "No employees found";
                                    }}
                                    loadingMessage={() => "Searching employees..."}
                                    onInputChange={(inputValue, { action }) => {
                                      // Only trigger search on user input, not on menu open/close
                                      if (action === 'input-change') {
                                        if (searchTimeout) {
                                          clearTimeout(searchTimeout);
                                        }
                                        const timeout = setTimeout(() => {
                                          searchEmployeeNamesManually(inputValue);
                                        }, 300);
                                        setSearchTimeout(timeout);
                                      }
                                      return inputValue;
                                    }}
                                    onChange={(selectedOption) => {
                                      handleSelectChange(selectedOption, 'employee_NameEn');
                                      // Clear search options after selection
                                      if (selectedOption) {
                                        setEmployeeNameSearchOptions([]);
                                      }
                                    }}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 99999 }) }}
                                  />
                                </div>
                              </Col>

                              <Col style={{ flex: '1', minWidth: '180px', maxWidth: '20%', paddingLeft: '8px', paddingRight: '8px' }}>
                                <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                  <Label htmlFor="filter_employee_Gender_Id">Gender</Label>
                                  <Select
                                    options={genderOptions}
                                    value={genderOptions.find(option => option.value === filter.employee_Gender_Id)}
                                    placeholder="Select"
                                    classNamePrefix="select2-selection"
                                    isClearable={true}
                                    isSearchable={true}
                                    onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_Gender_Id')}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 99999 }) }}
                                  />
                                </div>
                              </Col>

                              <Col style={{ flex: '1', minWidth: '180px', maxWidth: '20%', paddingLeft: '8px', paddingRight: '8px' }}>
                                <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                  <Label htmlFor="filter_employee_Country_Id">Country</Label>
                                  <Select
                                    options={countryOptions}
                                    value={countryOptions.find(option => option.value === filter.employee_Country_Id)}
                                    placeholder="Select"
                                    classNamePrefix="select2-selection"
                                    isClearable={true}
                                    isSearchable={true}
                                    onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_Country_Id')}
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 99999 }) }}
                                  />
                                </div>
                              </Col>

                              <Col style={{ flex: '1', minWidth: '180px', maxWidth: '20%', paddingLeft: '8px', paddingRight: '8px' }}>
                                <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                  <Label htmlFor="filter_employee_JoinDate">Join Date</Label>
                                  <Input
                                    type="date"
                                    className="form-control"
                                    id="filter_employee_JoinDate"
                                    name="employee_JoinDate"
                                    value={filter.employee_JoinDate || ""}
                                    onChange={handleFilterChange}
                                  />
                                </div>
                              </Col>

                              <Col style={{ flex: '1', minWidth: '180px', maxWidth: '20%', paddingLeft: '8px', paddingRight: '8px' }}>
                                <div className="form-group" style={{ marginBottom: '0.5rem' }}>
                                  <Label htmlFor="filter_employee_BirthDate">Birth Date</Label>
                                  <Input
                                    type="date"
                                    className="form-control"
                                    id="filter_employee_BirthDate"
                                    name="employee_BirthDate"
                                    value={filter.employee_BirthDate || ""}
                                    onChange={handleFilterChange}
                                  />
                                </div>
                              </Col>
                            </Row>

                            {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                            {/* System Filters */}
                            {/* <h6 className="text-primary mb-3">System Information</h6> */}
                            {/* <Row className="mb-3"> */}
                            {/*   <Col lg="4"> */}
                            {/*     <div className="form-group"> */}
                            {/*       <Label htmlFor="filter_employee_CreatedBy">Created By</Label> */}
                            {/*       <Select */}
                            {/*         options={createdByOptions} */}
                            {/*         value={createdByOptions.find(option => option.value === filter.employee_CreatedBy)} */}
                            {/*         placeholder="Select Created By" */}
                            {/*         classNamePrefix="select2-selection" */}
                            {/*         isClearable={true} */}
                            {/*         isSearchable={true} */}
                            {/*         onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_CreatedBy')} */}
                            {/*       /> */}
                            {/*     </div> */}
                            {/*   </Col> */}

                            {/*   <Col lg="4"> */}
                            {/*     <div className="form-group"> */}
                            {/*       <Label htmlFor="filter_employee_ModifiedBy">Modified By</Label> */}
                            {/*       <Select */}
                            {/*         options={modifiedByOptions} */}
                            {/*         value={modifiedByOptions.find(option => option.value === filter.employee_ModifiedBy)} */}
                            {/*         placeholder="Select Modified By" */}
                            {/*         classNamePrefix="select2-selection" */}
                            {/*         isClearable={true} */}
                            {/*         isSearchable={true} */}
                            {/*         onChange={(selectedOption) => handleSelectChange(selectedOption, 'employee_ModifiedBy')} */}
                            {/*       /> */}
                            {/*     </div> */}
                            {/*   </Col> */}

                            {/*   <Col lg="4"> */}
                            {/*     <div className="form-group"> */}
                            {/*       <Label htmlFor="filter_employee_CreatedDate">Created Date</Label> */}
                            {/*       <Input */}
                            {/*         type="date" */}
                            {/*         className="form-control" */}
                            {/*         id="filter_employee_CreatedDate" */}
                            {/*         name="employee_CreatedDate" */}
                            {/*         value={filter.employee_CreatedDate || ""} */}
                            {/*         onChange={handleFilterChange} */}
                            {/*       /> */}
                            {/*     </div> */}
                            {/*   </Col> */}
                            {/* </Row> */}

                            {/* MERLOT THEME - NEW VALUES (FILTERS REMOVED): */}
                            {/* System Information filters removed as requested */}

                            <div className="d-flex gap-2 mt-2">
                              <Button
                                color="primary"
                                onClick={handleApplyFilter}
                                disabled={loading}
                              >
                                Apply Filter
                              </Button>
                              <Button
                                color="warning"
                                onClick={handleClearFilter}
                              >
                                Clear Filter
                              </Button>
                            </div>
                          </CardBody>
                        </Card>
                      )}
                    </div>

                    {/* Employee Table */}
                    <Card style={{ backgroundColor: '#ffffff' }}>
                      <CardBody style={{ backgroundColor: '#ffffff', paddingTop: '0.5rem' }}>
                        {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                        {/* <h5 className="mb-3">Employee List ({employees.length} records)</h5> */}

                        {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                        <h6 className="mb-2" style={{ fontSize: '0.9rem' }}>Employee List ({employees.length} records)</h6>

                        {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                        {/* <div style={{ maxHeight: "60vh", overflowY: "auto", overflowX: "auto" }}> */}
                        {/*   <Table bordered responsive> */}

                        {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                        {loading ? (
                          <p>Loading employees...</p>
                        ) : (
                          <div style={{ overflowX: "auto" }} className="employee-list-optimized">
                            <Table bordered responsive className="table-optimized">
                              <thead>
                                <tr>
                                  <th>Sl.No</th>
                                  <th>Actions</th>
                                  <th>Profile Photo</th>
                                  <th>Employee Number</th>
                                  <th>Employee Name (English)</th>
                                  <th>Department</th>
                                  <th>Designation</th>
                                  <th>Branch</th>
                                  <th>Join Date</th>
                                  <th>Gross Salary</th>
                                  <th>Work Status</th>
                                  <th>Probation Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                {employees.length === 0 ? (
                                  <tr>
                                    <td colSpan="12" className="text-center">
                                      No employees found
                                    </td>
                                  </tr>
                                ) : (
                                  employees.map((emp, index) => (
                                    <tr key={emp.employee_Id}>
                                      <td>{(page - 1) * pageSize + index + 1}</td>
                                      <td>
                                        <div className="d-flex gap-2">
                                          {hasEditOrHigher && (
                                            <Button
                                              color="info"
                                              size="sm"
                                              onClick={() => handleEdit(emp)}
                                            >
                                              Edit
                                            </Button>
                                          )}
                                          <Button
                                            color="primary"
                                            size="sm"
                                            onClick={() => handleView(emp)}
                                          >
                                            View
                                          </Button>
                                        </div>
                                      </td>
                                      <td>
                                        {emp.employee_ImagePath ? (
                                          <img
                                            src={`${API_URL}${emp.employee_ImagePath}`}
                                            alt={emp.employee_NameEn}
                                            style={{
                                              width: '28px',
                                              height: '28px',
                                              borderRadius: '50%',
                                              objectFit: 'cover'
                                            }}
                                          />
                                        ) : (
                                          <div
                                            style={{
                                              width: '28px',
                                              height: '28px',
                                              borderRadius: '50%',
                                              backgroundColor: '#e9ecef',
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center'
                                            }}
                                          >
                                            <i className="bx bx-user" />
                                          </div>
                                        )}
                                      </td>
                                      <td>{emp.emp_No || emp.Emp_No || ''}</td>
                                      <td>{emp.employee_NameEn}</td>
                                      <td>{emp.department_name}</td>
                                      <td>{emp.designation_name}</td>
                                      <td>{emp.branch_name}</td>
                                      <td>{formatDate(emp.employee_JoinDate)}</td>
                                      <td className="text-end">{emp.employee_GS?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                      <td>
                                        <span className={`badge ${emp.onWork ? 'bg-success' : 'bg-secondary'}`}>
                                          {emp.onWork ? 'On Work' : 'Not On Work'}
                                        </span>
                                      </td>
                                      <td>
                                        <span className={`badge ${emp.employee_IsOnProbation ? 'bg-warning' : 'bg-success'}`}>
                                          {emp.employee_IsOnProbation ? 'On Probation' : 'Confirmed'}
                                        </span>
                                      </td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </Table>
                          </div>
                        )}

                        {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                        {/* <div className="d-flex justify-content-between align-items-center mt-4 p-3" 
                   style={{backgroundColor: '#f8f9fa', borderRadius: '0.375rem', border: '1px solid #dee2e6'}}> */}

                        {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                        <div className="d-flex justify-content-between align-items-center mt-2 p-2"
                          style={{ backgroundColor: '#f8f9fa', borderRadius: '0.375rem', border: '1px solid #dee2e6' }}>
                          {/* MERLOT THEME - ORIGINAL VALUES (for easy reversal): */}
                          {/* <div className="text-muted" style={{fontSize: '14px', fontWeight: '500'}}> */}

                          {/* MERLOT THEME - NEW VALUES (OPTIMIZED FOR SPACE): */}
                          <div className="text-muted" style={{ fontSize: '12px', fontWeight: '500' }}>
                            <i className="mdi mdi-information-outline me-2" style={{ color: '#556ee6' }}></i>
                            Showing <span style={{ color: '#556ee6', fontWeight: '600' }}>{employees.length > 0 ? (page - 1) * pageSize + 1 : 0}</span> to <span style={{ color: '#556ee6', fontWeight: '600' }}>{Math.min(page * pageSize, totalCount)}</span> of <span style={{ color: '#556ee6', fontWeight: '600' }}>{totalCount}</span> entries
                          </div>
                          {totalCount > pageSize && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <Button
                                color="light"
                                size="sm"
                                disabled={page === 1}
                                onClick={() => handlePageChange(page - 1)}
                                style={{
                                  border: '1px solid #dee2e6',
                                  borderRadius: '0.375rem',
                                  minWidth: '28px',
                                  height: '28px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  backgroundColor: page === 1 ? '#f8f9fa' : '#fff',
                                  color: page === 1 ? '#6c757d' : '#495057',
                                  fontSize: '0.8rem'
                                }}
                              >
                                <i className="mdi mdi-chevron-left"></i>
                              </Button>

                              {[...Array(Math.ceil(totalCount / pageSize))].map((_, index) => {
                                const pageNum = index + 1;
                                const isActive = page === pageNum;

                                return (
                                  <Button
                                    key={pageNum}
                                    color={isActive ? "primary" : "light"}
                                    size="sm"
                                    onClick={() => handlePageChange(pageNum)}
                                    style={{
                                      border: '1px solid #dee2e6',
                                      borderRadius: '0.375rem',
                                      minWidth: '28px',
                                      height: '28px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      backgroundColor: isActive ? '#556ee6' : '#fff',
                                      borderColor: isActive ? '#556ee6' : '#dee2e6',
                                      color: isActive ? '#fff' : '#495057',
                                      fontWeight: isActive ? '600' : '400',
                                      fontSize: '0.8rem',
                                      boxShadow: isActive ? '0 2px 4px rgba(85,110,230,0.25)' : 'none'
                                    }}
                                  >
                                    {pageNum}
                                  </Button>
                                );
                              })}

                              <Button
                                color="light"
                                size="sm"
                                disabled={page === Math.ceil(totalCount / pageSize)}
                                onClick={() => handlePageChange(page + 1)}
                                style={{
                                  border: '1px solid #dee2e6',
                                  borderRadius: '0.375rem',
                                  minWidth: '28px',
                                  height: '28px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  backgroundColor: page === Math.ceil(totalCount / pageSize) ? '#f8f9fa' : '#fff',
                                  color: page === Math.ceil(totalCount / pageSize) ? '#6c757d' : '#495057',
                                  fontSize: '0.8rem'
                                }}
                              >
                                <i className="mdi mdi-chevron-right"></i>
                              </Button>
                            </div>
                          )}
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Add the modal component */}
      <EmployeeDetailsModal
        isOpen={viewModal}
        toggle={() => setViewModal(!viewModal)}
        employee={selectedEmployee}
      />
    </React.Fragment>
  );
}